
import { ShieldAlert } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";

interface AuthenticationAlertProps {
  isAuthenticated: boolean;
}

export const AuthenticationAlert = ({ isAuthenticated }: AuthenticationAlertProps) => {
  if (isAuthenticated) return null;
  
  return (
    <Alert variant="destructive">
      <ShieldAlert className="h-4 w-4" />
      <AlertTitle>Authentication Required</AlertTitle>
      <AlertDescription>
        Please sign in to book appointments.
      </AlertDescription>
    </Alert>
  );
};
